import React, { useMemo } from 'react';
import { vesselTypes } from '../../util/varibles/constants';
import { FleetUtilizationItem, IVessel } from '../../util/varibles/interface';
import Sumary from './Sumary';
import Vessel from './Vessel';

interface IProps {
    sumary: FleetUtilizationItem[];
    vessels: IVessel[];
    countVessels: IVessel[];
    filteredCount: number;
}

const FleetOverview: React.FC<IProps> = React.memo(({ sumary, vessels, countVessels, filteredCount }) => {
    const summaryByVesselId = useMemo(
        () => new Map(sumary.map(item => [item.vessel_id, item])),
        [sumary]
    );
    const vesselsByType = useMemo(() => {
        const groupedVessels = new Map<IVessel['type'], IVessel[]>();

        vessels.forEach(vessel => {
            const vesselsOfType = groupedVessels.get(vessel.type) || [];
            vesselsOfType.push(vessel);
            groupedVessels.set(vessel.type, vesselsOfType);
        });

        return vesselTypes
            .map(type => ({
                ...type,
                vessels: groupedVessels.get(type.id) || [],
            }))
            .filter(group => group.vessels.length > 0);
    }, [vessels]);

    return <div className='grid grid-cols-[340px_minmax(0,1fr)] gap-[20px] relative h-[calc(100%-96px)] pb-3 -mx-[40px] '>
        <div className='pl-[40px] overflow-y-auto overflow-x-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
            <Sumary
                data={sumary}
                vessels={vessels}
                countVessels={countVessels}
                filteredCount={filteredCount}
            />
        </div>
        <div className='overflow-auto pr-[40px]'>
            {vesselsByType.map(group => <section key={group.id} className='mb-5'>
                <div className='flex flex-wrap content-start gap-3'>
                    {group.vessels.map(item => <Vessel
                        key={item.id}
                        data={item}
                        segments={summaryByVesselId.get(item.id)}
                    />)}
                </div>
            </section>)}
        </div>
    </div>;
});

export default FleetOverview;
